import Vue from "vue";
import Router from "vue-router";
import DashboardLayout from "../views/Starter/SampleLayout.vue";
import Starter from "../views/Starter/SamplePage.vue";
import Cantidades from "../views/Cantidades/Cantidades.vue";
import Receta from "../views/Recetas/Receta.vue";
import Insumos from "../views/Insumos/ListaInsumos.vue";
import InsumosFoodcourt from "../views/Insumos/ListaInsumosFoodcourt.vue";
import Consolidados from "../views/Consolidados/ListaConsolidados.vue";
import Metrics from "../views/Dashboard/Metrics";
import MetricasCocina from "../views/Foodcourt/MetricasCocina.vue";
import TiemposPreparacion from "../views/Foodcourt/TiemposPreparacion.vue";
import HistorialCarta from "../views/Foodcourt/HistorialCarta.vue";
import DisponibilidadHistorica from "../views/Foodcourt/DisponibilidadHistorica.vue";
import TiempoNoDisponible from "../views/Foodcourt/TiempoNoDisponible.vue";
// "Metricas" (/foodcourt/metric) es OTRA pagina: Calificacion, Cancelaciones,
// Disponibilidad y Tardanzas. Se saco del sidebar, pero la ruta se mantiene a
// proposito — ya vive en produccion y su eliminacion se revirtio en master
// (b10b56b). Ver la nota en SampleLayout.vue.
import MetricsFoodCourt from "../views/Foodcourt/Metric.vue";
import Login from "../views/login/login";
import store from "../store/index";
import ListReclamos from "../views/Reclamos/ListReclamos";
import ListFeedback from "../views/Feedback/ListFeedback";
import ListPedidos from "../views/Pedidos/ListPedidos";
import ListPedidosTienda from "../views/PedidosTienda/ListPedidosTienda";
import DetallePedidoTienda from "../views/PedidosTienda/DetallePedidoTienda";
import ControlStockTienda from "../views/PedidosTienda/ControlStockTienda";
import RedeemGift from "../views/Gifts/RedeemGift";
import operationsManualRoutes from "./operationsManualRoutes";
import kitchenChargesRoutes from "@/views/KitchenCharges/kitchenChargesRoutes";
import ListNiveles from "../views/Niveles/ListNiveles";
import ListBonification from "../views/Bono/ListBonification";
import ListRecipe from "../views/Recetas/RecipeList";
import ListEsperaRepartidor from "../views/EsperaRepartidor/ListEsperaRepartidor";
import ListFacturas from "../views/Facturas/ListFacturas";
import Precantidades from "../views/Precantidades/ListaPrecantidades.vue";
import PrecantidadesFoodcourt from "../views/Precantidades/ListaPrecantidadesFoodcourt.vue";
import ListCalificacion from "../views/Calificacion/ListCalificacion";
import Evaluaciones from "../views/Evaluaciones/Evaluaciones";
import EvaluacionCategorias from "../views/Evaluaciones/Categorias";
import EvaluacionCategoriaFAQ from "../views/Evaluaciones/FAQ";
import FoodcourtPedidosList from "../views/FoodcourtPedidos/FoodcourtPedidosList.vue";
import ForecastList from "../views/Forecast/ForecastList.vue";
import FoodcourtRestaurantsList from "../views/FoodcourtRestaurants/FoodcourtRestaurantsList";
import FoodcourtCargosList from "../views/FoodcourtCargos/FoodcourtCargosList.vue";
import FoodcourtMenuList from "../views/FoodcourtMenu/FoodcourtMenuList.vue";
import FoodcourtLevelsList from "../views/FoodcourtLevels/FoodcourtLevelsList.vue";
import FoodCourtReceta from "@/views/FoodcourtReceta/FoodCourtReceta.vue";
import FoodCourtRecetaV2 from "@/views/FoodcourtReceta/RecipeDetail.vue";
import FoodcourtFeedbackList from "../views/FoodcourtFeedback/FoodcourtFeedbackList.vue";
import FoodcourtClaimsList from "../views/FoodcourtClaims/FoodcourtClaimsList.vue";
import ListTasks from "../views/Evaluaciones/Tasks";
import FoodcourtPlatformList from "@/views/FoodcourtPlatform/FoodcourtPlatformList.vue";
import FoodcourtOrderStatusBoard from "@/views/FoodcourtOrderStatusBoard/FoodcourtOrderStatusBoard.vue";
import auth from "../store/modules/auth";
import FranchisesFeedback from "@/views/Franchises/Feedback.vue"
import Checklist from "@/views/Supervisor/Checklist.vue"
import PesosCocidos from "@/views/PesosCocidos/PesosCocidosList.vue"
import Delivery from "@/views/Delivery/Delivery.vue"
import AuditoriasHome from "@/views/Auditorias/AuditoriasHome.vue"
import IntervencionesHome from "@/views/Auditorias/IntervencionesHome.vue"
import DetalleAuditoria from "@/views/Auditorias/DetalleAuditoria.vue"

Vue.use(Router);

const router = new Router({
  linkActiveClass: "active",
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { auth: false }
    },
    {
      path: "/",
      name: "home",
      redirect: "/pedidos",
      component: DashboardLayout,

      children: [
        ...operationsManualRoutes,
        ...kitchenChargesRoutes,
        {
          path: "pesos",
          name: "pesos",
          meta: { auth: true },
          components: { default: Starter }
        },
        {
          path: "cantidades",
          name: "cantidades",
          meta: { auth: true },
          components: { default: Cantidades }
        },
        {
          path: "receta/:id",
          name: "receta",
          meta: { auth: true },
          components: { default: Receta }
        },
        {
          path: "insumos",
          name: "insumos",
          meta: { auth: true },
          components: { default: Insumos }
        },
        {
          path: "insumos/foodcourt",
          name: "insumos_foodcourt",
          meta: { auth: true },
          components: { default: InsumosFoodcourt }
        },
        {
          path: "precantidades",
          name: "precantidades",
          meta: { auth: true },
          components: { default: Precantidades }
        },
        {
          path: "precantidades/foodcourt",
          name: "precantidades_foodcourt",
          meta: { auth: true },
          components: { default: PrecantidadesFoodcourt }
        },
        {
          path: "consolidados",
          name: "consolidados",
          meta: { auth: true, permiso: "ver consolidados" },
          components: { default: Consolidados }
        },
        /* {
          path: "metrics",
          name: "metrics",
          meta: { auth: true , permiso: "ver dashboard" },
          components: { default: Metrics }
        }, */
        {
          path: "dashboard",
          name: "dashboard",
          meta: { auth: true, permiso: "ver dashboard" },
          components: { default: Metrics }
        },
        {
          path: "bonificacion",
          name: "bonificacion",
          meta: { auth: true, permiso: "ver bonificacion" },
          components: { default: ListBonification }
        },
        {
          path: "reclamos",
          name: "reclamos",
          meta: { auth: true },
          components: { default: ListReclamos }
        },
        {
          path: "auditorias",
          name: "auditorias",
          meta: { auth: true },
          components: { default: AuditoriasHome }
        },
        {
          path: "auditorias/intervenciones",
          name: "auditorias-intervenciones",
          meta: { auth: true },
          components: { default: IntervencionesHome }
        },
        {
          path: "auditorias/:id",
          name: "auditorias-detalle",
          meta: { auth: true },
          components: { default: DetalleAuditoria }
        },
        {
          path: "feedback",
          name: "feedback",
          meta: { auth: true },
          components: { default: ListFeedback }
        },
        {
          path: "calificacion",
          name: "calificacion",
          meta: { auth: true },
          components: { default: ListCalificacion }
        },
        {
          path: "pedidos",
          name: "pedidos",
          meta: { auth: true },
          components: { default: ListPedidos }
        },
        {
          path: "pedidos-tienda",
          name: "pedidos-tienda",
          meta: { auth: true },
          components: { default: ListPedidosTienda }
        },
        {
          path: "pedidos-tienda/control-stock",
          name: "pedidos-tienda-control-stock",
          meta: { auth: true },
          components: { default: ControlStockTienda }
        },
        {
          path: "pedidos-tienda/:id",
          name: "pedidos-tienda-detalle",
          meta: { auth: true },
          components: { default: DetallePedidoTienda }
        },
        {
          path: "regalos/canjear",
          name: "regalos-canjear",
          meta: { auth: true },
          components: { default: RedeemGift }
        },
        {
          path: "niveles",
          name: "niveles",
          meta: { auth: true },
          components: { default: ListNiveles }
        },
        {
          path: "recetas",
          name: "recetas",
          meta: { auth: true },
          components: { default: ListRecipe }
        },
        {
          path: "espera-del-repartidor",
          name: "espera-del-repartidor",
          meta: { auth: true },
          components: { default: ListEsperaRepartidor }
        },
        {
          path: "rutas",
          name: "rutas",
          redirect: { name: "espera-del-repartidor" }
        },
        {
          path: "facturas",
          name: "facturas",
          meta: { auth: true, permiso: "ver facturas"},
          components: { default: ListFacturas }
        },
        {
          path: "evaluaciones",
          name: "evaluaciones",
          meta: { auth: true },
          components: { default: Evaluaciones }
        },
        {
          path: "evaluaciones/tareas",
          name: "evaluaciones_tareas",
          meta: { auth: true },
          components: { default: ListTasks }
        },
        {
          path: "evaluaciones/:id/categorias",
          name: "evaluacion_categorias",
          meta: { auth: true },
          components: { default: EvaluacionCategorias }
        },
        {
          path: "evaluaciones/:id/categorias/:faq",
          name: "evaluacion_categoria_faq",
          meta: { auth: true },
          components: { default: EvaluacionCategoriaFAQ }
        },
        {
          path: "foodcourt/pedidos",
          name: "foodcourt_pedidos",
          meta: { auth: true },
          components: { default: FoodcourtPedidosList }
        },
        {
          path: "forecast/produccion",
          name: "forecast_produccion",
          meta: { auth: true },
          components: { default: ForecastList }
        },
        {
          // Se mantiene aunque no este en el sidebar: es una pagina distinta
          // de "Metricas de cocina" y ya vive en produccion. Quitarla se
          // reintento una vez y se revirtio (b10b56b).
          path: "foodcourt/metric",
          name: "foodcourt_metric",
          meta: { auth: true },
          components: { default: MetricsFoodCourt }
        },
        {
          // Metricas de cocina OD del catering autenticado: % reclamos,
          // rating apps, tiempo de preparacion y % carta activa (los 4
          // indicadores del ticket). Unica entrada de metricas del sidebar:
          // "foodcourt/metric" (Foodcourt/Metric.vue, Calificacion de
          // pedidos/Cancelaciones/Disponibilidad/Tardanzas) ya no esta
          // enlazada a pedido explicito.
          path: "foodcourt/metricas-cocina",
          name: "foodcourt_metricas_cocina",
          meta: { auth: true },
          components: { default: MetricasCocina }
        },
        {
          // Detalle por pedido de la card "Tiempo de preparacion".
          path: "foodcourt/tiempos-preparacion",
          name: "foodcourt_tiempos_preparacion",
          meta: { auth: true },
          components: { default: TiemposPreparacion }
        },
        {
          // Detalle de la card "% Tiempo no disponible": que dias la cocina
          // estuvo cerrada debiendo abrir. Lee el mismo endpoint que las
          // metricas, para que su % no pueda divergir del de la card.
          path: "foodcourt/tiempo-no-disponible",
          name: "foodcourt_tiempo_no_disponible",
          meta: { auth: true },
          components: { default: TiempoNoDisponible }
        },
        {
          // Que platos se cayeron y que dia: el detalle HACIA ATRAS de la card
          // "% Carta activa". Es el destino de la card porque descompone su
          // numero; desde aca se llega al historial de quien lo hizo.
          path: "foodcourt/carta-disponibilidad",
          name: "foodcourt_carta_disponibilidad",
          meta: { auth: true },
          components: { default: DisponibilidadHistorica }
        },
        {
          // Quien apago/prendio cada plato (complemento de "% Carta activa").
          path: "foodcourt/carta-historial",
          name: "foodcourt_carta_historial",
          meta: { auth: true },
          components: { default: HistorialCarta }
        },
        {
          path: "foodcourt/pedidos/estados",
          name: "foodcourt_pedidos_estados",
          meta: { auth: true },
          components: { default: FoodcourtOrderStatusBoard }
        },
        {
          path: "foodcourt/restaurantes",
          name: "foodcourt_restaurantes",
          meta: { auth: true },
          components: { default: FoodcourtRestaurantsList }
        },
        {
          path: "foodcourt/cargos",
          name: "foodcourt_cargos",
          meta: { auth: true },
          component: FoodcourtCargosList
        },
        {
          path: "foodcourt/feedback",
          name: "foodcourt_feedback",
          meta: { auth: true },
          components: { default: FoodcourtFeedbackList }
        },
        {
          path: "foodcourt/claims",
          name: "foodcourt_claims",
          meta: { auth: true },
          components: { default: FoodcourtClaimsList }
        },
        {
          path: "foodcourt/platforms",
          name: "foodcourt_platform",
          meta: { auth: true },
          components: { default: FoodcourtPlatformList }
        },
        {
          path: "foodcourt/niveles",
          name: "foodcourt_niveles",
          meta: { auth: true },
          components: { default: FoodcourtLevelsList }
        },
        {
          path: "foodcourt/restaurant/:restaurantId?",
          name: "foodcourt_restaurant_menu",
          meta: { auth: true },
          component: FoodcourtMenuList
        },
        {
          path: "foodcourt/receta/:id",
          name: "foodcourt_receta",
          meta: { auth: true },
          components: { default: FoodCourtReceta }
        },
        {
          path: "foodcourt/receta-v2/:id",
          name: "foodcourt_receta_v2",
          meta: { auth: true },
          components: { default: FoodCourtRecetaV2 }
        },
        {
          path: "franquicias/feedback",
          name: "franquicias_feedback",
          meta: { auth: true },
          components: { default: FranchisesFeedback }
        },
        {
          path: "supervisor/checklist",
          name: "supervisor_checklist",
          meta: { auth: true },
          components: { default: Checklist }
        },
        {
          path: "pesos-cocidos",
          name: "pesos_cocidos",
          meta: { auth: true },
          components: { default: PesosCocidos }
        },
        {
          path: "delivery",
          name: "delivery",
          meta: { auth: true },
          components: { default: Delivery }
        },
      ]
    }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});
router.beforeEach((to, from, next) => {
  if (!store.getters.isLogged && to.meta.auth) {
    return next("/login");
  }
  if (store.getters.isLogged && !to.meta.auth) {
    return next("/pedidos");
  }
  let permisos = store.getters.getPermissions;
  if (to.meta.permiso !== undefined && !permisos[to.meta.permiso]) {
    return next("/403");
  }
  next();
});
export default router;
